import { render, staticRenderFns } from "./ItemsCarousel.vue?vue&type=template&id=17bd3fa2&scoped=true"
import script from "./ItemsCarousel.vue?vue&type=script&lang=ts"
export * from "./ItemsCarousel.vue?vue&type=script&lang=ts"
import style0 from "./ItemsCarousel.vue?vue&type=style&index=0&id=17bd3fa2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bd3fa2",
  null
  
)

export default component.exports